export enum NotfallplanSearchFields {
    ELEVATOR_ID = 'elevatorId',
    FACOTRY_NUMBER = 'factoryNumber',
    INSPECTION_DATE = 'inspectionDate',
}